import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllDeposit from '../deposit/AllDeposit'

function DepositRoute() {
  return (
    <>
      <Routes>
        <Route path='/all-deposit' element={<AllDeposit/>}/>
      </Routes>
    </>
  )
}

export default DepositRoute
